import { ClothingData } from "../../data/clothing/clothing.data";
import { ClothingImgData } from "../../data/clothing/clothing-img.data";
import { ClothingStoreData } from "../../data/clothing/clothing-store.data";
import { ClothingToTagData } from "../../data/clothing/clothing-to-tag.data";
import { PaginationQueryDto } from "../../dto/pagination-query.dto";
import { ApiConfig } from "../../lib/request/api-config";

export const getClothingByCategoryApi: ApiConfig = {
  url: "/wx-api/clothing/by-category",
  method: "get",
};

export interface GetClothingByCategoryDto extends PaginationQueryDto {
  /**
   * 服装分类id
   * categoryId 为空时查询所有分类的服装
   */
  categoryId?: string;

  /**
   * 店铺id
   */
  storeId: string;
}

export interface ClothingByCategoryDto extends ClothingData {
  imgs: ClothingImgData[];

  coverImg: null | ClothingImgData;

  tags: ClothingToTagData[];
  storeList: ClothingStoreData[];
}
